import {computed} from "vue";
import {baseUseStore} from "@/components/auth/store";

export const useAuth = () => {
    const store = baseUseStore();
    const loginUser = async (usuarioSign) => await store.dispatch('signInUser', usuarioSign);
    const checkAuthStatus = async () => await store.dispatch('checkAuth');
    const logoutUser = async () => await store.dispatch('unregisterUser');
    return {
        loginUser,
        checkAuthStatus,
        logoutUser,
        authStatus: computed(() => store.getters['currentStatus']),
        authUser: computed(() => store.getters['currentUser']),
        authToken: computed(() => store.getters['currentToken'])
    }
};